module.exports = __webpack_public_path__ + "img/close.9dd7d83a.svg";